<template>
  <div class="produto_page">
    <v-toolbar extended height="auto" color="black">
      <div
        class="d-flex flex-column align-start justify-space-around cont"
        style="height: 100%"
      >
        <img
          class="diageo"
          src="../img/logo.png"
          width="75"
          alt="Logo Diageo"
        />
        <p class="categoria">
          {{ garrafa.dsCategoria }}
          <span class="segmento">{{ garrafa.dsSegmento }}</span>
        </p>
        <p class="produto">{{ garrafa.dsGarrafa }}</p>
      </div>
      <div>
        <v-btn icon @click="this.handleBack">
          <img
            class="btnBack"
            src="../img/right-arrow.png"
            width="30"
            alt="Botão voltar"
          />
        </v-btn>
      </div>
    </v-toolbar>
      <v-row> 
        <v-progress-circular
          indeterminate
          class="mx-auto mt-5"
          v-if="loading"
          color="#FF8723"
        ></v-progress-circular>
      </v-row>
    <section class="px-4 mt-10 pt-0">
      <h1 class="subTitle">{{ bebida.dsTipo }}</h1>
      <v-row style="max-width:100vw">
        <v-col class="pr-0" cols="9">
          <h1 style="font-size: 1.2rem; color: #000; line-height: 1.1">
            {{ bebida.dsBebida }}
          </h1>
          <div class="d-flex flex-row align-center mt-2" style="width: 100%;">
            <v-col class="d-flex flex-row align-center px-0 py-0" cols="4">
              <div
                class="circle d-flex align-center justify-center mr-1"
                style="width: 30px; height: 30px;"
              >
                <img src="../img/heat.png" width="20" alt="" />
              </div>
              <span
                >{{
                  bebida.dsTeorAlc === null
                    ? garrafa.dsTeorAlc
                    : bebida.dsTeorAlc
                }}%</span
              >
            </v-col>
            <v-col class="d-flex flex-row align-center px-0 py-0" cols="8">
              <div
                class="circle d-flex align-center justify-center mr-1"
                style="width: 30px; height: 30px;"
              >
                <img src="../img/cash.png" width="20" alt="" />
              </div>
              <span>{{ bebida.vlDe }} ~ {{ bebida.vlAte }}</span>
            </v-col>
          </div>
        </v-col>
        <v-col class="pl-0 d-flex align-center justify-center" cols="3">
          <img :src="$drink_img_uri +'bebida/'+ bebida.idBebida +'.png'" width="100px">
        </v-col>
      </v-row>
    </section>

    <v-row class="mt-5 d-flex justify-center" style="max-width: 100vw;">
      <span class="divider"></span>
    </v-row>

    <section class="px-4 mt-4 pt-0">
      <h1 class="subTitle">Receita</h1>
      <v-row style="max-width:100vw">
        <v-col style="max-width:90%">
          <p style="line-height: 1.3; font-size: 1.07rem; white-space: pre-wrap;">{{ bebida.dsReceita }}</p>
        </v-col>
      </v-row>
    </section>

    <v-row class="mt-5 d-flex justify-center" style="max-width: 100vw;">
      <span class="divider"></span>
    </v-row>

    <section class="px-4 mt-4 pt-0">
      <h1 class="subTitle">Calculadora de rentabilidade</h1>
      <v-row v-if="bebida.dsTipo != 'RTD'">
        <v-col cols="2" style="max-width: 60px !important;">
          <div
            class="circle d-flex align-center justify-center"
            style="width: 40px; height: 40px;"
          >
            <img src="../img/cocktail.png" width="25" alt="Icone garrafa" />
          </div>
        </v-col>
        <v-col  class="pl-0">
          <h2>Litragem da Garrafa (ml)</h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="garrafa.dsLitragem">
          <v-btn-toggle v-model="litragemSelected" mandatory color="#FF8723">
            <v-btn
              min-width="30vw"
              color="white"
              v-for="l in garrafa.dsLitragem.split(',')"
              :key="l"
              small
              class="btnToggle"
            >
              <!-- <v-icon>mdi-format-align-left</v-icon> -->
              {{ l }}
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2" style="max-width: 60px !important;">
          <div
            class="circle d-flex align-center justify-center"
            style="width: 40px; height: 40px;"
          >
            <img src="../img/cocktail.png" width="25" alt="Icone garrafa" />
          </div>
        </v-col>
        <v-col class="pl-0">
          <h2 v-show="!isDose">{{bebida.dsTipo}}</h2>
          <h2 v-show="isDose">Dose</h2>
        </v-col>
      </v-row>
      <v-col class="px-0 py-0" style="max-width:100vw">
        <v-text-field
          class="inputCalc pt-2 mt-2"
          type="number"
          prefix="R$"
          v-model="drk.precoGarrafa"
          color="#FF8723"
          label="Quanto pagou pelo produto?"
        >
        </v-text-field>
        <v-text-field
          class="inputCalc pt-2 mt-2"
          type="number"
          prefix="R$"
          v-show="!isDose"
          :disabled="isRTD"
          label="Custos dos insumos para um drink"
          v-model="drk.custoInsumos"
          color="#FF8723"
        >
        </v-text-field>
        <v-text-field
          class="inputCalc pt-2 mt-2"
          type="number"
          prefix="R$"
          :label="'Preço praticado d' + (isDose ? 'a dose' : 'o drink')"
          v-model="drk.precoDrink"
          color="#FF8723"
        >
        </v-text-field>
        <v-text-field
          class="inputCalc pt-2 mt-2"
          type="number"
          prefix="Qt"
          label="Quantidade vendida em um dia"
          v-model="drk.qtdeVendida"
          color="#FF8723"
        >
        </v-text-field>
      </v-col>

      <v-row class="pt-2">
        <v-col cols="2" style="max-width: 60px !important;">
          <div
            class="circle d-flex align-center justify-center"
            style="width: 40px; height: 40px;"
          >
            <img src="../img/beer.png" width="25" alt="Icone produto" />
          </div>
        </v-col>
        <v-col class="pl-0">
          <h2>Outra Bebida</h2>
        </v-col>
      </v-row>
      <v-col class="px-0 py-0" style="max-width:100vw">
        <v-text-field
          class="inputCalc pt-2 mt-2"
          type="number"
          v-model="cerv.custoBebida"
          prefix="R$"
          label="Custo de uma bebida"
          color="#FF8723"
        >
        </v-text-field>
        <v-text-field
          class="inputCalc pt-2 mt-2"
          type="number"
          v-model="cerv.precoBebida"
          prefix="R$"
          color="#FF8723"
          label="Preço praticado"
        >
        </v-text-field>
        <v-text-field
          class="inputCalc pt-2 mt-2"
          type="number"
          v-model="cerv.qtdeVendida"
          prefix="Qt"
          label="Quantidade vendida em um dia"
          color="#FF8723"
        >
        </v-text-field>
      </v-col>
    </section>

    <section class="px-4 mt-4 pt-0">
      <h1 class="subTitle">Resultado</h1>
      <v-row class="d-flex justify-space-around mt-2">
        <v-card class="py-3 mb-7" min-width="170px">
          <v-row style="width: 100%; margin: 0 auto;">
            <v-col class="pt-0" cols="2" style="max-width: 60px !important;">
              <div
                class="circle d-flex align-center justify-center"
                style="width: 30px; height: 30px;"
              >
                <img
                  src="../img/cocktail.png"
                  height="20"
                  alt="Icone drink"
                />
              </div>
            </v-col>
            <v-col class="pl-0 pt-0">
              <h3 v-show="!isDose">Drink</h3>
              <h3 v-show="isDose">Dose</h3>
            </v-col>
          </v-row>
          <div
            class="px-3"
            style="width: 100%; margin: 0 auto; line-height: 1.1;"
          >
            <p>Lucro Unitário</p>
            <span
              ><b>R$ {{ drk.lucroUnit.toFixed(2) }}</b></span
            >
          </div>
          <div
            class="px-3 mt-2"
            style="width: 100%; margin: 0 auto; line-height: 1.1;"
          >
            <p>Lucro diário</p>
            <span
              ><b>R$ {{ drk.lucroDia.toFixed(2) }}</b></span
            >
          </div>
        </v-card>

        <v-card class="py-3 mb-7" min-width="170px">
          <v-row style="width: 100%; margin: 0 auto;">
            <v-col class="pt-0" cols="2" style="max-width: 60px !important;">
              <div
                class="circle d-flex align-center justify-center"
                style="width: 30px; height: 30px;"
              >
                <img src="../img/beer.png" height="23" alt="Icone bebida" />
              </div>
            </v-col>
            <v-col class="pl-0 pt-0">
              <h3>Bebida</h3>
            </v-col>
          </v-row>
          <div
            class="px-3"
            style="width: 100%; margin: 0 auto; line-height: 1.1;"
          >
            <p>Lucro Unitário</p>
            <span
              ><b>R$ {{ cerv.lucroUnit.toFixed(2) }}</b></span
            >
          </div>
          <div
            class="px-3 mt-2"
            style="width: 100%; margin: 0 auto; line-height: 1.1;"
          >
            <p>Lucro diário</p>
            <span
              ><b>R$ {{ cerv.lucroDia.toFixed(2) }}</b></span
            >
          </div>
        </v-card>
      </v-row>
    </section>
  </div>
</template>

<script>
import "../css/produto.css";

export default {
  name: "bebida",
  components: {},
  data() {
    return {
      litragemSelected: 750,
      garrafa: {
        categoria: "Whisky",
        segmento: "Super Deluxe",
        produto: "Johnnie Walker Blue Label",
      },
      cerv: {
        custoBebida: "",
        precoBebida: "",
        qtdeVendida: "",
        lucroUnit: 0.0,
        lucroDia: 0.0,
      },
      drk: {
        precoGarrafa: "",
        custoInsumos: "",
        precoDrink: "",
        qtdeVendida:"",
        lucroUnit: 0.0,
        lucroDia: 0.0,
      },
      bebida: {},
      loading: false,
    };
  },
  created() {
    const idBebida = this.$route.params.idBebida;
    this.loading = true;
    window.scrollTo(0,0);

    fetch(this.$drink_uri + "/get-bebida/" + idBebida,
    {headers: {
      'Authorization': `Bearer ${localStorage.tokenDrink}`
    },
      credentials: "include"})
      .then((response) => response.json())
      .then((data) => {
        this.bebida = data[0];
        if (this.bebida.idGarrafa != null) { 
          fetch(this.$drink_uri + "/get-garrafa/" + this.bebida.idGarrafa,
          {headers: {
      'Authorization': `Bearer ${localStorage.tokenDrink}`,
      credentials: "include"
    },
      credentials: "include"})
            .then((response) => response.json())
            .then((data) => {
              this.garrafa = data[0]
            })
        }
        this.loading = false;
        this.$forceUpdate();

      });
  },
  computed: {
    isDose() {
      return this.bebida.dsTipo === "DOSE";
    },
    isRTD() { 
      return this.bebida.dsTipo == "RTD"
    }
  },
  watch: {
    litragemSelected() {
      this.calcDrinkUnitario();
    },
    "drk.precoGarrafa": function() {
      this.calcDrinkUnitario();
    },
    "drk.custoInsumos": function() {
      this.calcDrinkUnitario();
    },
    "drk.precoDrink": function() {
      this.calcDrinkUnitario();
    },
    "drk.qtdeVendida": function(nVal) {
      this.drk.lucroDia = this.drk.lucroUnit * nVal;
    },
    "cerv.custoBebida": function() {
      this.calcBebidaUnitario();
    },
    "cerv.precoBebida": function() {
      this.calcBebidaUnitario();
    },
    "cerv.qtdeVendida": function(nVal) {
      this.cerv.lucroDia = this.cerv.lucroUnit * nVal;
    },
  },
  methods: {
    calcDrinkUnitario() {
      let litragemSelected = 50
      if (this.bebida.idGarrafa != null) {
        litragemSelected = parseInt(
          this.garrafa.dsLitragem.split(",")[this.litragemSelected]
        );
      }
      let qtdeDoses = litragemSelected / 50;
      let tmpPrecoGarrafa =
        this.drk.precoGarrafa !== "" ? parseFloat(this.drk.precoGarrafa) : 0;
      let tmpCustoInsumos =
        this.drk.custoInsumos !== "" ? parseFloat(this.drk.custoInsumos) : 0;
      let custoDrink = tmpPrecoGarrafa / qtdeDoses + tmpCustoInsumos;
      let tmpPrecoDrink =
        this.drk.precoDrink !== "" ? parseFloat(this.drk.precoDrink) : 0;
      // window.console.log({litragemSelected, qtdeDoses, tmpPrecoGarrafa, tmpCustoInsumos, custoDrink, tmpPrecoDrink})
      this.drk.lucroUnit = tmpPrecoDrink - custoDrink;  
      this.drk.lucroDia = this.drk.lucroUnit * this.drk.qtdeVendida;

    },
    calcBebidaUnitario() {
      let tmpCustoBebida =
      this.cerv.custoBebida !== "" ? parseFloat(this.cerv.custoBebida) : 0;
      let tmpPrecoBebida =
      this.cerv.precoBebida !== "" ? parseFloat(this.cerv.precoBebida) : 0;
      this.cerv.lucroUnit = tmpPrecoBebida - tmpCustoBebida;
      this.cerv.lucroDia = this.cerv.lucroUnit * this.cerv.qtdeVendida;
    },
    handleBack() {
      this.$router.back();
    },
    calc() {
      console.log("Calc");
    },
  },
};
</script>
